import styled from 'styled-components'

const FormMessage = styled.p`
  margin-top: 0;
  margin-bottom: 6px;
`

export default FormMessage
